PJQ.views.resources.ResourceAllocation = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.RESOURCES, 'resource-allocation'),
		subTemplates: {
			scheduleLegend: new PJQ.templating.Template(PJQ.constants.modules.RESOURCES, 'resource-schedule-legend'),
			resourceGroups: new PJQ.templating.Template(PJQ.constants.modules.RESOURCES, 'resource-allocation-groups'),
			resourceGroupItem: new PJQ.templating.Template(PJQ.constants.modules.RESOURCES, 'resource-allocation-group-item')
		},
	},
	events: {
		'click .resource-allocation-settings': 'settings',
		'click .last-4week': 'dateRangeButtonClicked',
		'click .last-week': 'dateRangeButtonClicked',
		'click .next-4week': 'dateRangeButtonClicked',
		'click .next-week': 'dateRangeButtonClicked',
		'click .resource-project-name': 'viewProject',
		'click .btn-edit-project': 'viewProject',
		'click .add-event': 'addEvent',
		'click .btn-edit-event': 'editEvent',
		'click .export': 'exportView'
	},
	beforeFirstRender: function () {
		this.projects = null;
		this.settings = new PJQ.models.resources.ResourceAllocationManagerViewSettings();
		this.settings.fetch({
			success: _.bind(function () {
				PJQ.app.session.fetchProjectStatuses(_.bind(function () {
					this.resources = new PJQ.collections.resources.Resources();
					this.resources.fetch({
						success: _.bind(function () {
							this.isFetched = true;
							this.render();
						}, this)
					});
				}, this));
			}, this)
		});
	},
	renderData: function () {
		return {
			isFetched: this.isFetched,
			projectStatuses: PJQ.app.session.projectStatuses ? PJQ.app.session.projectStatuses.models : []
		};
	},
	afterRender: function () {
		if (!this.isFetched)
			return;

		// find most recent Monday
		let startDateDefault = new Date(PJQ.helpers.dateHelpers.getDateString(new Date(), PJQ.helpers.dateHelpers.dateFormats.DATE)),
			startDayDefault = startDateDefault.getDay();
		if (startDayDefault !== 1) {
			if (startDayDefault === 0)
				startDateDefault = startDateDefault.addDays(-7);
			else
				startDateDefault = startDateDefault.addDays(-(startDayDefault - 1))
		}

		this.startDateDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.start-date'),
			datepickerOptions: {
				defaultDate: startDateDefault,
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
			},
			disabledDays: [0, 2, 3, 4, 5, 6],
			onChange: _.bind(function () {
				this.renderView();
			}, this)
		});

		this.groupBySelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.group-by'),
			isIntChoices: true,
			defaultValue: this.settings.get('defaultGroupBy'),
			onChange: _.bind(function () {
				this.renderView();
			}, this)
		});

		let defaultFilter = {};
		defaultFilter[PJQ.constants.resources.filterType.PROJECT_FILTER] = [this.settings.get('defaultProjectFilter')];
		defaultFilter[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER] = [];

		if (_.size(this.settings.get('defaultProjectStatuses')) > 0)
			defaultFilter[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER].push(...this.settings.get('defaultProjectStatuses'));
		else
			defaultFilter[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER].push(PJQ.app.session.projectStatuses.getDefault().get('projectStatusId'));

		this.filterSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.project-filter'),
			isIntChoices: true,
			isMultiple: true,
			isGrouped: true,
			mustSelectValuePerOptGroup: true,
			exclusiveChoices: [PJQ.constants.resources.projectFilter.ALL_PROJECTS, PJQ.constants.resources.projectFilter.MY_PROJECTS],
			defaultValue: defaultFilter,
			onChange: _.bind(function () {
				this.renderView(true);
			}, this)
		});

		this.renderView();
	},
	getData: function (forceRefresh, callback) {
		let callback2 = _.bind(function () {
			this.groups = []
			let startDate = this.startDateDatePicker.getValue(), endDate = startDate.addDays(7 * 12);
			if (this.groupBySelectPicker.getValue() === PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_PROJECT) {
				let upcomingProjects = [];
				_.each(this.resources.getProjectManagers(), _.bind(function (resource) {
					let group = {
						resource: resource,
						projects: this.projects.getProjectsAssociatedWithId(resource.get('id'), this.settings.get('isShowAllProjectsWithStatus'))
					};

					if (this.settings.get('isGroupUpcomingProjects')) {
						group.projects = _.filter(group.projects, function (project) {
							if (PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false) < startDate.addDays(7)) {
								return true;
							}
							else {
								upcomingProjects.push(project);
								return false;
							}
						});
					}

					if (_.size(group.projects) > 0 || !this.settings.get('isHideEmptyGroups'))
						this.groups.push(group);

				}, this));

				if (_.size(upcomingProjects) > 0) {
					let upcomingProjectsResource = new PJQ.models.resources.Resource();
					upcomingProjectsResource.set('id', -1);
					upcomingProjectsResource.set('contactName', 'Upcoming Projects');
					this.groups.push({
						resource: upcomingProjectsResource,
						projects: _.sortBy(upcomingProjects, function(project) { return project.get('startDate'); })
					});
				}

			}
			else if (this.groupBySelectPicker.getValue() === PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_RESOURCE) {
				_.each(this.resources.getProjectManagers(), _.bind(function (resource) {
					let group = {
						resource: resource,
						resources: this.projects.getSuperintendentsWithProjectsAssociatedWithId(resource.get('id'), this.resources.getSuperintendents(), false, this.startDateDatePicker.getValue(), this.events)
					};

					if (_.size(group.resources) > 0 || !this.settings.get('isHideEmptyGroups'))
						this.groups.push(group);

				}, this));

				// add unassigned projects (no supers assigned)
				let unassignedProjects = this.projects.getProjectsWithoutSuperintendents(this.startDateDatePicker.getValue());
				if (_.size(unassignedProjects) > 0) {
					let unassignedResource = new PJQ.models.resources.Resource();
					unassignedResource.set('id', -1);
					unassignedResource.set('contactName', 'Unassigned Projects');

					let group = {
						resource: unassignedResource,
						resources: []
					};

					group.resources.push({
						resource: {
							id: -2,
							contactName: 'Project List'
						},
						items: unassignedProjects
					});

					this.groups.push(group);
				}

				let unassignedSupers = [];
				_.each(this.resources.getSuperintendents(), _.bind(function (resource) {
					if (!resource.get('isActive')) {
						return;
					}

					let hasScheduleWeekOne = false,
						projects = _.filter(this.projects.getProjectsAssociatedWithId(resource.id, false), _.bind(function (project) {
							let projectDates = project.getProjectResourceDates(resource.id);

							if (PJQ.helpers.dateHelpers.parseDateString(projectDates.startDate, false) < startDate.addDays(7) && PJQ.helpers.dateHelpers.parseDateString(projectDates.endDate, false) > startDate)
								hasScheduleWeekOne = true;

							return (PJQ.helpers.dateHelpers.parseDateString(projectDates.startDate, false) < endDate && PJQ.helpers.dateHelpers.parseDateString(projectDates.endDate, false) > startDate);
						}, this));

					if (!hasScheduleWeekOne) {
						unassignedSupers.push({
							resource: resource,
							items: _.sortBy(_.union(projects, this.events.getEventsForResource(resource.id)), function (item) {
								return item.get('startDate');
							})
						});
					}
				}, this));

				if (_.size(unassignedSupers) > 0) {
					let unassignedResource = new PJQ.models.resources.Resource();
					unassignedResource.set('id', -2);
					unassignedResource.set('contactName', 'Unassigned Resources');
					this.groups.push({
						resource: unassignedResource,
						resources: unassignedSupers
					});
				}

			}
			else if (this.groupBySelectPicker.getValue() === PJQ.constants.resources.allocationManagerGroupBy.RESOURCE_PROJECT_MANAGER) {
				_.each(this.resources.getSuperintendents(), _.bind(function (resource) {
					let group = {
						resource: resource,
						resources: this.projects.getProjectManagersWithProjectsAssociatedWithId(resource.get('id'), this.resources.getProjectManagers(), false, this.startDateDatePicker.getValue(), this.events)
					};

					if (_.size(group.resources) > 0 || !this.settings.get('isHideEmptyGroups'))
						this.groups.push(group);

				}, this));
			}
			callback();
		}, this);

		if (forceRefresh || !this.projects || !this.settings.get('isShowAllProjectsWithStatus')) {
			this.projects = new PJQ.collections.resources.Projects();
			this.events = new PJQ.collections.resources.ResourceScheduleEvents();

			this.projects.fetch({
				data: {
					projectStatuses: this.filterSelectPicker.getValue()[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER],
					startDate: this.settings.get('isShowAllProjectsWithStatus') ? null : PJQ.helpers.dateHelpers.getDateString(this.startDateDatePicker.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE),
					endDate: this.settings.get('isShowAllProjectsWithStatus') ? null : PJQ.helpers.dateHelpers.getDateString(this.startDateDatePicker.getValue().addDays(7 * 12), PJQ.helpers.dateHelpers.dateFormats.DATE),
					idFilter: this.filterSelectPicker.getValue()[PJQ.constants.resources.filterType.PROJECT_FILTER].indexOf(PJQ.constants.resources.projectFilter.MY_PROJECTS) !== -1 ? (PJQ.app.session.get('user') ? PJQ.app.session.get('user').id : PJQ.app.session.get('contact').id) : null
				},
				type: 'POST',
				success: _.bind(function () {
					this.events.fetch({
						data: {
							startDate: this.settings.get('isShowAllProjectsWithStatus') ? null : PJQ.helpers.dateHelpers.getDateString(this.startDateDatePicker.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE),
							endDate: this.settings.get('isShowAllProjectsWithStatus') ? null : PJQ.helpers.dateHelpers.getDateString(this.startDateDatePicker.getValue().addDays(7 * 12), PJQ.helpers.dateHelpers.dateFormats.DATE),
						},
						type: 'POST',
						success: _.bind(function () {
							callback2();
						}, this)
					});
				}, this),
				fail: _.bind(function () {
				}, this)
			});
		}
		else
			callback2();
	},
	renderView: function (forceRefresh) {

		let legendElements = [], defaultColorElements = [];
		_.each(this.filterSelectPicker.getValue()[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER], function (projectStatusId) {
			if (PJQ.app.session.projectStatuses.get(projectStatusId)) {
				let projectStatus = PJQ.app.session.projectStatuses.get(projectStatusId);
				if (projectStatus.get('color') === '000000')
					defaultColorElements.push(projectStatus.get('name'));
				else
					legendElements.push({label: projectStatus.get('name'), color: projectStatus.get('color')});
			}
		});

		if (_.size(defaultColorElements) > 0) {
			legendElements.unshift({
				label: defaultColorElements.join(', '),
				color: PJQ.constants.resources.colors.default
			});
		}

		if (this.groupBySelectPicker.getValue() !== PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_PROJECT)
			legendElements.push({label: 'Resource Event', color: PJQ.constants.resources.colors.other});

		if (this.groupBySelectPicker.getValue() === PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_PROJECT)
			legendElements.push({label: 'Warning', color: PJQ.constants.resources.colors.warning});

		this.renderSubTemplate(false, this.options.subTemplates.scheduleLegend, this.$('.schedule-legend'), {
			legendElements: legendElements
		});

		this.getData(forceRefresh, _.bind(function () {
			if (_.size(this.groups) === 0) {
				this.$('.resource-groups-empty').show();
				this.$('.schedule-legend, .resource-groups').hide();
			}
			else {
				this.$('.resource-groups-empty').hide();
				this.$('.schedule-legend, .resource-groups').show();

				let projectCustomFieldColorBar = null;
				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESOURCE_ALLOCATION_PROJECT_CUSTOM_FIELD_COLOR_BAR)) {
					let values = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESOURCE_ALLOCATION_PROJECT_CUSTOM_FIELD_COLOR_BAR).split('|');
					projectCustomFieldColorBar = {
						customFieldId: values[0],
						value: values[1],
						color: values[2]
					};
				}

				this.renderSubTemplate(false, this.options.subTemplates.resourceGroups, this.$('.resource-groups'), {
					groups: this.groups,
					resources: this.resources,
					subTemplates: this.options.subTemplates,
					startDate: this.startDateDatePicker.getValue(),
					groupBy: this.groupBySelectPicker.getValue(),
					projectStatuses: PJQ.app.session.projectStatuses,
					projectCustomFieldColorBar: projectCustomFieldColorBar
				}, _.bind(function () {
					let scheduleWidthDayPixels = (PJQ.constants.resources.scheduleWidthDay / 100.0) * this.$('.schedule-row').width(),
						self = this;

					new PJQ.Draggable(this.$('.resource-schedule-event'), {
						opacity: 0.9,
						zIndex: 1000000,
						axis: (this.groupBySelectPicker.getValue() !== PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_RESOURCE) ? "x" : null,
						cursor: (this.groupBySelectPicker.getValue() !== PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_RESOURCE) ? "auto" : "move",
						scroll: true,
						revert: function (valid) {
							if (!valid) {
								$(this).offset($(this).data('originalOffset'));
							}

							return false;
						},
						snap: '.schedule-row',
						snapMode: 'inner',
						snapTolerance: (this.groupBySelectPicker.getValue() === PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_RESOURCE) ? 28 : null,
						stack: '.resource-schedule-event',
						grid: [scheduleWidthDayPixels, 1],
						start: function (event, ui) {
							ui.helper.data('originalPosition', ui.position);
							ui.helper.data('originalOffset', ui.helper.offset());
						},
						drag: function (event, ui) {
							if (ui.position.left < 0)
								ui.position.left = 0;

							if (ui.position.left > ui.helper.parent().width() - 10)
								ui.position.left = ui.helper.parent().width() - 10;

							// resource events cannot be moved up or down
							if (self.groupBySelectPicker.getValue() === PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_RESOURCE &&
								ui.helper.find('.resource-schedule').data('resourceScheduleId') > 0)
								ui.position.top = ui.originalPosition.top;

						}
					});

					new PJQ.Droppable(this.$('.schedule-row'), {
						accept: function ($event) {
							if ($event.find('.resource-schedule').data('resourceScheduleId'))
								return true;

							return ($event.closest('.schedule-row')[0] === $(this)[0]) || ($event.find('.resource-schedule').data('resourceId') !== $(this).closest('.resource-resource').data('resourceId'));
						},
						drop: function (e, ui) {

							let days = Math.round((ui.position.left - ui.helper.data('originalPosition').left) / scheduleWidthDayPixels),
								project = null,
								resource = null,
								event = null,
								$eventContainer = ui.helper.find('div.resource-schedule'),
								originalStartDate = null,
								originalEndDate = null,
								originalResourceId = $eventContainer.data('resourceId'),
								currentResourceId = (self.groupBySelectPicker.getValue() === PJQ.constants.resources.allocationManagerGroupBy.PROJECT_MANAGER_PROJECT) ? originalResourceId : $(this).closest('.resource-resource').data('resourceId');

							if (days === 0 && originalResourceId === currentResourceId)
								return;

							if ($eventContainer.data('resourceScheduleId')) {
								event = self.events.get($eventContainer.data('resourceScheduleId'));
								resource = self.resources.get(event.get('resourceId'));
								originalStartDate = event.get('startDate');
								originalEndDate = event.get('startDate');
								event.set('startDate', PJQ.helpers.dateHelpers.parseDateString(event.get('startDate'), false).addDays(days));
								event.set('endDate', PJQ.helpers.dateHelpers.parseDateString(event.get('endDate'), false).addDays(days));
							}
							else {

								if ($eventContainer.data('projectId'))
									project = self.projects.get($eventContainer.data('projectId'));

								if ($eventContainer.data('resourceId'))
									resource = project.getProjectResource($eventContainer.data('resourceId'));

								if (currentResourceId === PJQ.constants.resources.resourceIdUnassignedProjects)
									resource = null;
								else if (originalResourceId !== currentResourceId && !resource) {
									resource = {
										id: currentResourceId,
										startDate: null,
										endDate: null
									};
								}

								if (resource && resource.startDate) {
									originalStartDate = resource.startDate;
									originalEndDate = resource.endDate;
									resource.startDate = PJQ.helpers.dateHelpers.parseDateString(resource.startDate, false).addDays(days);
									resource.endDate = PJQ.helpers.dateHelpers.parseDateString(resource.endDate, false).addDays(days);
								}
								else if (project) {
									originalStartDate = project.get('startDate');
									originalEndDate = project.get('endDate');
									project.set('startDate', PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false).addDays(days));
									project.set('endDate', PJQ.helpers.dateHelpers.parseDateString(project.get('endDate'), false).addDays(days));
								}
							}

							new PJQ.views.resources.EditEventModal({
								project: project,
								resource: resource,
								event: event,
								resources: self.resources,
								originalResourceId: originalResourceId === PJQ.constants.resources.resourceIdUnassignedProjects ? null : originalResourceId,
								currentResourceId: currentResourceId === PJQ.constants.resources.resourceIdUnassignedProjects ? null : currentResourceId,
								title: 'Confirm Schedule Change',
								onSave: function () {
									self.renderView(true);
								},
								onCancel: function () {
									if (event) {
										event.set('startDate', originalStartDate);
										event.set('endDate', originalEndDate);
									}
									else {
										if (resource && resource.startDate) {
											resource.startDate = originalStartDate;
											resource.endDate = originalEndDate;
										}
										else if (project) {
											project.set('startDate', originalStartDate);
											project.set('endDate', originalEndDate);
										}

										if (resource)
											resource.id = originalResourceId;
									}
									ui.helper.offset(ui.helper.data('originalOffset'));
								}
							});
						}
					});

					_.each(this.$('.resource-schedule-event'), _.bind(function (event) {
						let $event = $(event), handles = [];

						if ($event.position().left > 0)
							handles.push('w');
						if (($event.parent().width() - ($event.position().left + $event.width())) > 5)
							handles.push('e');

						if (_.size(handles) === 0)
							return;

						new PJQ.Resizable($event, {
							handles: handles.join(','),
							grid: [scheduleWidthDayPixels, 0],
							start: function (e, ui) {
								ui.helper.data('originalOffset', ui.helper.offset());
								ui.helper.data('originalWidth', ui.helper.css('width'));

								$(this).resizable("option", "minWidth", scheduleWidthDayPixels);

								// need to figure this out depending on whether we are dragging left side or right side.
								let maxWidth = $(e.toElement).hasClass('ui-resizable-w') ? (ui.helper.position().left + ui.helper.width() + 5) : ui.helper.width() + (ui.helper.parent().width() - (ui.helper.position().left + ui.helper.width())) + 5;
								$(this).resizable("option", "maxWidth", maxWidth);
							},
							stop: _.bind(function (e, ui) {
								let days = $(e.toElement).hasClass('ui-resizable-w') ? Math.round((ui.position.left - ui.originalPosition.left) / scheduleWidthDayPixels) : Math.round((ui.size.width - ui.originalSize.width) / scheduleWidthDayPixels),
									project = null,
									resource = null,
									event = null,
									$eventContainer = ui.helper.find('div.resource-schedule'),
									originalStartDate = null,
									originalEndDate = null;

								if (days === 0)
									return;

								if ($eventContainer.data('resourceScheduleId')) {
									event = this.events.get($eventContainer.data('resourceScheduleId'));
									resource = this.resources.get(event.get('resourceId'));
									originalStartDate = event.get('startDate');
									originalEndDate = event.get('startDate');

									if ($(e.toElement).hasClass('ui-resizable-w'))
										event.set('startDate', PJQ.helpers.dateHelpers.parseDateString(event.get('startDate'), false).addDays(days));
									else
										event.set('endDate', PJQ.helpers.dateHelpers.parseDateString(event.get('endDate'), false).addDays(days));
								}
								else {
									if ($eventContainer.data('projectId'))
										project = this.projects.get($eventContainer.data('projectId'));

									if ($eventContainer.data('resourceId'))
										resource = project.getProjectResource($eventContainer.data('resourceId'));

									if (resource && resource.startDate) {
										originalStartDate = resource.startDate;
										originalEndDate = resource.endDate;
										if ($(e.toElement).hasClass('ui-resizable-w'))
											resource.startDate = PJQ.helpers.dateHelpers.parseDateString(resource.startDate, false).addDays(days);
										else
											resource.endDate = PJQ.helpers.dateHelpers.parseDateString(resource.endDate, false).addDays(days);
									}
									else if (project) {
										originalStartDate = project.get('startDate');
										originalEndDate = project.get('endDate');
										if ($(e.toElement).hasClass('ui-resizable-w'))
											project.set('startDate', PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false).addDays(days));
										else
											project.set('endDate', PJQ.helpers.dateHelpers.parseDateString(project.get('endDate'), false).addDays(days));
									}
								}

								new PJQ.views.resources.EditEventModal({
									project: project,
									resource: resource,
									event: event,
									resources: this.resources,
									title: 'Confirm Schedule Change',
									onSave: _.bind(function () {
										this.renderView(true);
									}, this),
									onCancel: _.bind(function () {
										if (event) {
											event.set('startDate', originalStartDate);
											event.set('endDate', originalEndDate);
										}
										else {
											if (resource && resource.startDate) {
												resource.startDate = originalStartDate;
												resource.endDate = originalEndDate;
											}
											else if (project) {
												project.set('startDate', originalStartDate);
												project.set('endDate', originalEndDate);
											}
										}

										ui.helper.offset(ui.helper.data('originalOffset'));
										ui.helper.css('width', ui.helper.data('originalWidth'));
									}, this)
								});

							}, this)
						});

					}, this));

				}, this));
			}
		}, this));
	},
	dateRangeButtonClicked: function (e) {
		let target = $(e.currentTarget), dayOffset = 0;
		if (target.hasClass('last-week'))
			dayOffset = -7;
		else if (target.hasClass('last-4week'))
			dayOffset = -28;
		else if (target.hasClass('next-week'))
			dayOffset = 7;
		else if (target.hasClass('next-4week'))
			dayOffset = 28;

		this.startDateDatePicker.setValue(this.startDateDatePicker.getValue().addDays(dayOffset));

		this.renderView();
	},
	settings: function () {
		new PJQ.views.resources.ResourceAllocationSettingsModal({
			resourceAllocationView: this,
			onSave: _.bind(function () {
				this.renderView(true);
				PJQ.notifications.notify.successNotify({
					message: 'Settings updated successfully'
				});
			}, this)
		});
	},
	viewProject: function (e) {
		let projectId = $(e.currentTarget).hasClass('resource-project-name') ? $(e.currentTarget).data('projectId') : $(e.currentTarget).closest('div.resource-schedule').data('projectId');
		PJQ.app.router.navigate('projects/' + projectId, {
			trigger: true,
			replace: false
		});
	},
	addEvent: function (e) {
		// select resource
		let userTypes = [];
		_.each(PJQ.app.session.userTypes.models, _.bind(function (userType) {
			if (userType.get('isSuperintendent'))
				userTypes.push(userType.id);
		}, this));

		new PJQ.views.contacts.SelectContactsModal({
			isSingleChoice: true,
			//userTypeFilter: userTypes,
			isUserTypeFilterDisabled: true,
			context: PJQ.constants.contacts.contexts.PARTICIPANTS,
			titleOverride: 'Select Resource',
			contacts: new PJQ.collections.resources.Resources(this.resources.getSuperintendents()),
			onSave: _.bind(function (newContact) {

				let event = new PJQ.models.resources.ResourceScheduleEvent();
				event.set('resourceId', newContact.id);

				new PJQ.views.resources.EditEventModal({
					resource: this.resources.get(newContact.id),
					event: event,
					resources: this.resources,
					onSave: _.bind(function () {
						this.renderView(true);
					}, this)
				});
			}, this)
		});

	},
	editEvent: function (e) {
		let project = null,
			resource = null,
			event = null,
			$eventContainer = $(e.currentTarget).closest('div.resource-schedule');

		if ($eventContainer.data('resourceScheduleId')) {
			event = this.events.get($eventContainer.data('resourceScheduleId'));
			resource = this.resources.get(event.get('resourceId'));
		}
		else {

			if ($eventContainer.data('projectId'))
				project = this.projects.get($eventContainer.data('projectId'));

			if ($eventContainer.data('resourceId'))
				resource = project.getProjectResource($eventContainer.data('resourceId'));
		}

		new PJQ.views.resources.EditEventModal({
			project: project,
			resource: resource,
			event: event,
			resources: this.resources,
			onSave: _.bind(function () {
				this.renderView(true);
			}, this)
		});
	},
	exportView: function () {
		let loader = new PJQ.Loader(this.$('.btn-export'), {
			type: 'button',
			loadingText: 'Exporting'
		});
		new PJQ.models.reporting.Report({
			name: 'resource-allocation',
			fileName: 'ResourceSchedule'
		}).generate({
			html: this.$('.resource-allocation').outerHTML()
		}, function () {
			loader.remove();
		});
	}
});

// Modals
PJQ.views.resources.ResourceAllocationSettingsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.RESOURCES, 'modal-resource-allocation-settings'),
		width: '600px',
		resourceAllocationView: null
	},
	events: {
		'click button.settings-save': 'onSave'
	},
	beforeModalCreated: function () {
	},
	renderData: function () {
		return {
			projectStatuses: PJQ.app.session.projectStatuses.models
		};
	},
	afterRender: function () {
		this.groupBySelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.group-by-default'),
			isIntChoices: true,
			defaultValue: this.options.resourceAllocationView.settings.get('defaultGroupBy')
		});

		let defaultFilter = {};
		defaultFilter[PJQ.constants.resources.filterType.PROJECT_FILTER] = [this.options.resourceAllocationView.settings.get('defaultProjectFilter')];
		defaultFilter[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER] = [];
		if (_.size(this.options.resourceAllocationView.settings.get('defaultProjectStatuses')) > 0)
			defaultFilter[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER].push(...this.options.resourceAllocationView.settings.get('defaultProjectStatuses'));
		else
			defaultFilter[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER].push(PJQ.app.session.projectStatuses.getDefault().get('projectStatusId'));

		this.filterSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.filter-default'),
			isIntChoices: true,
			isMultiple: true,
			isGrouped: true,
			mustSelectValuePerOptGroup: true,
			exclusiveChoices: [PJQ.constants.resources.projectFilter.ALL_PROJECTS, PJQ.constants.resources.projectFilter.MY_PROJECTS],
			defaultValue: defaultFilter
		});

		this.$('.show-all-projects-with-status').prop('checked', this.options.resourceAllocationView.settings.get('isShowAllProjectsWithStatus'));
		this.$('.hide-empty-groups').prop('checked', this.options.resourceAllocationView.settings.get('isHideEmptyGroups'));
		this.$('.group-upcoming-projects').prop('checked', this.options.resourceAllocationView.settings.get('isGroupUpcomingProjects'));
	},
	onSave: function () {
		this.options.resourceAllocationView.settings.set('defaultGroupBy', this.groupBySelectPicker.getValue());

		let filterValue = this.filterSelectPicker.getValue();
		this.options.resourceAllocationView.settings.set('defaultProjectFilter', filterValue[PJQ.constants.resources.filterType.PROJECT_FILTER][0]);
		this.options.resourceAllocationView.settings.set('defaultProjectStatuses', filterValue[PJQ.constants.resources.filterType.PROJECT_STATUS_FILTER]);

		this.options.resourceAllocationView.settings.set('isShowAllProjectsWithStatus', this.$('.show-all-projects-with-status').prop('checked'));
		this.options.resourceAllocationView.settings.set('isHideEmptyGroups', this.$('.hide-empty-groups').prop('checked'));
		this.options.resourceAllocationView.settings.set('isGroupUpcomingProjects', this.$('.group-upcoming-projects').prop('checked'));

		this.options.resourceAllocationView.settings.save(null, {
			success: _.bind(function () {
				if (typeof this.options.onSave === 'function')
					this.options.onSave();

				this.removeModal();
			}, this)
		});
	}
});

PJQ.views.resources.EditEventModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.RESOURCES, 'modal-edit-event'),
		width: '600px',
		project: null,
		resource: null,
		event: null,
		resources: null,
		onSave: _.noop(),
		onCancel: _.noop()
	},
	events: {
		'click button.event-save': 'onSave',
		'click button.event-cancel': 'onCancel',
		'click .project-name': 'viewProject',
		'click .resource-schedule-override': 'scheduleOverride'
	},
	beforeModalCreated: function () {
	},
	renderData: function () {
		let resourceId = this.options.currentResourceId !== 0 ? this.options.currentResourceId : (this.options.resource ? this.options.resource.id : null);
		return {
			project: this.options.project,
			projectResource: this.options.resource,
			scheduleEvent: this.options.event,
			resource: resourceId ? this.options.resources.get(resourceId) : null
		};
	},
	afterRender: function () {
		if (this.options.title)
			this.$('div.title').text(this.options.title);
		else if (this.options.event && this.options.event.isNew())
			this.$('div.title').text('Add Schedule');

		if (this.options.project) {
			this.projectStartDatePicker = new PJQ.inputs.Datepicker({
				el: this.$('.project-start-date'),
				datepickerOptions: {
					format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
					defaultDate: PJQ.helpers.dateHelpers.parseDateString(this.options.project.get('startDate'), false)
				}
			});

			this.projectEndDatePicker = new PJQ.inputs.Datepicker({
				el: this.$('.project-end-date'),
				datepickerOptions: {
					format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
					defaultDate: PJQ.helpers.dateHelpers.parseDateString(this.options.project.get('endDate'), false)
				}
			});
		}

		let defaultStartDate = null;
		if (this.options.project && this.options.resource) {
			this.$('.resource-start-date').prop('disabled', !this.options.resource.startDate);
			defaultStartDate = this.options.resource.startDate ? PJQ.helpers.dateHelpers.parseDateString(this.options.resource.startDate, false) : PJQ.helpers.dateHelpers.parseDateString(this.options.project.get('startDate'), false);
		}
		else if (this.options.event) {
			defaultStartDate = PJQ.helpers.dateHelpers.parseDateString(this.options.event.get('startDate'), false);
		}

		this.resourceStartDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.resource-start-date'),
			datepickerOptions: {
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
				defaultDate: defaultStartDate
			}
		});

		let defaultEndDate = null;
		if (this.options.project && this.options.resource) {
			this.$('.resource-end-date').prop('disabled', !this.options.resource.endDate);
			defaultEndDate = this.options.resource.endDate ? PJQ.helpers.dateHelpers.parseDateString(this.options.resource.endDate, false) : PJQ.helpers.dateHelpers.parseDateString(this.options.project.get('endDate'), false);
		}
		else if (this.options.event) {
			defaultEndDate = PJQ.helpers.dateHelpers.parseDateString(this.options.event.get('endDate'), false);
		}

		this.resourceEndDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.resource-end-date'),
			datepickerOptions: {
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
				defaultDate: defaultEndDate
			}
		});

		if (this.options.event) {
			this.$('.event-description').val(this.options.event.get('eventText'));
		}

	},
	onCancel: function () {
		if (typeof this.options.onCancel === 'function')
			this.options.onCancel();

		this.removeModal();
	},
	onSave: function () {
		let hasErrors = false, errors = [];
		if (this.options.project) {
			PJQ.helpers.inputHelpers.setInputError(this.projectStartDatePicker.$el, this.projectStartDatePicker.getValue());
			PJQ.helpers.inputHelpers.setInputError(this.projectEndDatePicker.$el, this.projectEndDatePicker.getValue());

			if (!this.projectStartDatePicker.getValue() || !this.projectEndDatePicker.getValue()) {
				hasErrors = true;
				errors.push('Project Start and End Date are required.');
			}
			else if (PJQ.helpers.dateHelpers.parseDateString(this.projectStartDatePicker.getValue(), false) > PJQ.helpers.dateHelpers.parseDateString(this.projectEndDatePicker.getValue(), false)) {
				hasErrors = true;
				errors.push('Project Start Date cannot be after Project End Date.');
				PJQ.helpers.inputHelpers.setInputError(this.projectStartDatePicker.$el, false);
				PJQ.helpers.inputHelpers.setInputError(this.projectEndDatePicker.$el, false);
			}
		}

		if (this.options.resource || this.options.event) {
			PJQ.helpers.inputHelpers.setInputError(this.resourceStartDatePicker.$el, true);
			PJQ.helpers.inputHelpers.setInputError(this.resourceEndDatePicker.$el, true);
			if (!this.$('.resource-start-date').prop('disabled')) {
				PJQ.helpers.inputHelpers.setInputError(this.resourceStartDatePicker.$el, this.resourceStartDatePicker.getValue());
				PJQ.helpers.inputHelpers.setInputError(this.resourceEndDatePicker.$el, this.resourceEndDatePicker.getValue());
				if (!this.resourceStartDatePicker.getValue() || !this.resourceEndDatePicker.getValue()) {
					hasErrors = true;
					errors.push('Resource Start and End Date are required.');
				}
				else if (PJQ.helpers.dateHelpers.parseDateString(this.resourceStartDatePicker.getValue(), false) > PJQ.helpers.dateHelpers.parseDateString(this.resourceEndDatePicker.getValue(), false)) {
					hasErrors = true;
					errors.push('Resource Start Date cannot be after Resource End Date.');
					PJQ.helpers.inputHelpers.setInputError(this.resourceStartDatePicker.$el, false);
					PJQ.helpers.inputHelpers.setInputError(this.resourceEndDatePicker.$el, false);
				}
			}
		}

		let $description = this.$('.event-description');
		if (this.options.event) {
			PJQ.helpers.inputHelpers.setInputError($description, true);
			if (_.size($description.val()) === 0) {
				PJQ.helpers.inputHelpers.setInputError($description, false);
				hasErrors = true;
				errors.push('Description is required.');
			}
		}

		if (hasErrors) {
			PJQ.notifications.notify.errorNotify({
				message: errors.join(' ')
			});
			return;
		}

		if (this.options.project) {
			this.options.project.set('startDate', this.projectStartDatePicker.getValue());
			this.options.project.set('endDate', this.projectEndDatePicker.getValue());

			if (this.options.resource) {
				if (!this.$('.resource-start-date').prop('disabled')) {
					this.options.resource.startDate = this.resourceStartDatePicker.getValue();
					this.options.resource.endDate = this.resourceEndDatePicker.getValue();
				}
				else {
					this.options.resource.startDate = null;
					this.options.resource.endDate = null;
				}
			}

		}
		else if (this.options.event) {
			this.options.event.set('startDate', this.resourceStartDatePicker.getValue());
			this.options.event.set('endDate', this.resourceEndDatePicker.getValue());
			this.options.event.set('eventText', $description.val());
		}

		let callback = _.bind(function () {
			if (typeof this.options.onSave === 'function')
				this.options.onSave();

			PJQ.notifications.notify.successNotify({
				message: 'Schedule saved successfully'
			});
			this.removeModal();
		}, this);

		if (this.options.project) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'resources'
					},
					{
						endpoint: 'schedule'
					},
				]),
				data: {
					projectId: this.options.project ? this.options.project.get('projectId') : null,
					projectStartDate: this.options.project ? this.options.project.get('startDate') : null,
					projectEndDate: this.options.project ? this.options.project.get('endDate') : null,
					resourceId: this.options.resource ? this.options.resource.id : this.options.originalResourceId,
					resourceStartDate: this.options.resource ? this.options.resource.startDate : null,
					resourceEndDate: this.options.resource ? this.options.resource.endDate : null,
					currentResourceId: this.options.currentResourceId
				}
			}).post().done(_.bind(function (data) {
				callback();
			}, this)).fail(_.bind(function (xhr, err, result) {
				PJQ.notifications.notify.errorNotify({
					message: 'Something went wrong!'
				});
			}, this));
		}
		else if (this.options.event) {
			this.options.event.save(null, {
				success: _.bind(callback, this)
			});
		}
	},
	viewProject: function (e) {
		this.removeModal();
		PJQ.app.router.navigate('projects/' + $(e.currentTarget).data('projectId'), {
			trigger: true,
			replace: false
		});
	},
	scheduleOverride: function (e) {
		let button = $(e.currentTarget);
		if (button.hasClass('override')) {
			button.removeClass('override').removeClass('btn-light').addClass('btn-success').text('Override');
			this.$('.resource-start-date, .resource-end-date').prop('disabled', true);
			this.resourceStartDatePicker.setValue(PJQ.helpers.dateHelpers.parseDateString(this.options.project.get('startDate'), false));
			this.resourceEndDatePicker.setValue(PJQ.helpers.dateHelpers.parseDateString(this.options.project.get('endDate'), false));
		}
		else {
			button.addClass('override').addClass('btn-light').removeClass('btn-success').text('Revert');
			this.$('.resource-start-date, .resource-end-date').prop('disabled', false);
			this.resourceStartDatePicker.setValue(null);
			this.resourceEndDatePicker.setValue(null);
		}
	}
});
